import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import QueueCard from './QueueCard'
import { useV3Styles } from './v3Styles'

const QueueList = ({ items, loading, selectedId, onSelect }) => {
  const classes = useV3Styles()

  if (loading) {
    return (
      <div className={classes.queuePanel}>
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress size={28} />
        </Box>
      </div>
    )
  }

  return (
    <div className={classes.queuePanel}>
      <div style={{ padding: '8px 12px', fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid #f0f0f0' }}>
        Queue — sorted by priority + urgency
      </div>
      {!items.length ? (
        <Box p={3}>
          <Typography color="textSecondary" variant="body2" align="center">
            No sites match the current filters.
          </Typography>
        </Box>
      ) : (
        items.map(item => (
          <QueueCard
            key={item._id}
            item={item}
            selected={item._id === selectedId}
            onClick={onSelect}
          />
        ))
      )}
    </div>
  )
}

export default QueueList
